module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-12-e754e5931a4bc26d0af5bb6160e31a90.svg";